<template>
  <div id="card" class="panels">
    <div class="panel-left-flex">
      <h3>Add Card</h3>
      <p>We dedected that neither you or your company have a card on file for payment. We require a card to make your bookings and charge our booking fees.</p>
      <Card v-model:is-new="isCardSuccess" :organization-id="organizationId" />
      <div id="navigation">
        <a @click="back">Back</a>
      </div>
    </div>
    <FAQ class="panel-right-40-percent" :faqs="faqList" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import Card from "../components/common/CardForm.vue";
import FAQ from "../components/common/FaqPanel.vue";

const emit = defineEmits(["createTrip", "update:isCard", "update:stage"]);
defineProps(["organizationId"]);

const isCardSuccess = ref(false);
watch(
  () => isCardSuccess.value,
  val => {
    if (val === true) {
      emit("update:isCard", true);
      emit("createTrip");
    }
  }
);

const back = () => {
  emit("update:stage", "wizard");
};

const faqList = [
  {
    question: "Why do you require a card?",
    answer: "For self bookings, we require a card to pay the travel provider. For assisted and concierge requests, we require a card to charge our fees.",
  },
  {
    question: "Why must I pay now?",
    answer: 'You must pay now to book travel, but if you would like to discuss your travel with our team upfront, please <a href="https://flightfox.com/contact" target="_blank">contact our team</a>.',
  },
  {
    question: "When do you charge my card?",
    answer: "For self bookings, we charge for your bookings immediately. For assisted and concierge requests, we only charge our fees immediately.",
  },
];
</script>

<style lang="less">
#card {
  .panel-left-flex {
    p {
      color: @secondary;
      margin-bottom: 2rem;
    }
  }

  #navigation {
    margin-top: -3.625rem;
  }
}
</style>
